import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { LoadingService } from '@mds/ngx-core';
import { EMPTY, finalize, first, map } from 'rxjs';
import { DeploymentInstanceResponse, DeploymentsClient } from '../../../shared';

export const deploymentInstanceResolver: ResolveFn<
  DeploymentInstanceResponse
> = (route: ActivatedRouteSnapshot) => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(LoadingService);
  const router = inject(Router);
  const snackbar = inject(MatSnackBar);
  const translocoService = inject(TranslocoService);

  const deploymentId = Number(route.paramMap.get('deploymentId'));
  const instanceId = Number(route.paramMap.get('deploymentInstanceId'));
  const isEditRoute = route.routeConfig?.path === 'edit';

  if (Number.isNaN(deploymentId)) {
    void router.navigate(['deployments']);
    return EMPTY;
  }

  loadingService.start();

  return client.getDeploymentInstanceById(deploymentId, instanceId).pipe(
    first(),
    map((response) => {
      if (isEditRoute && response.isReadOnly) {
        snackbar.open(
          translocoService.translate(
            _('i18n.DeploymentInstance.Edit.ReadOnly'),
            {
              name: response.name,
            },
          ),
          translocoService.translate(_('i18n.Common.Button.Ok')),
        );

        void router.navigate([
          'deployments',
          deploymentId,
          'instances',
          instanceId,
          'detail',
        ]);
      }

      return response;
    }),
    finalize(() => loadingService.end()),
  );
};
